import React from 'react';
import { bootstrap } from '@framework/app';
import './notFound.less';
import PageJump from '@util/pageJump';
import PcPublic from '../../../component/pc/index';

const NotFound = () => {
  return (
    <div className="not-found">
      <PcPublic />
      <div className="icon" />
      <p className="status">404</p>
      <p className="desc">哎呀，您访问的页面飞向外太空跑丢了～</p>
      <div className="backhome-btn" onClick={PageJump.toHome}>
        返回首页
      </div>
    </div>
  );
};

export default bootstrap(NotFound, { isMobile: false, wxShare: false });
